import { ITirPmSkeletonLoaderStyleVars } from "./ITirPmSkeletonLoaderStyleVars";

export class TirPmSkeletonLoaderStyleVars implements ITirPmSkeletonLoaderStyleVars {
  "--tir-pm-skeleton-loader__color" = "var(--neutral-10, #eaeaeb)";
  "--tir-pm-skeleton-loader__shimmer-color" = "var(--neutral-20, #d4d5d7)";
  "--tir-pm-skeleton-loader__animation-duration" = "1.5s";

  static setVars(vars: TirPmSkeletonLoaderStyleVars) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${vars[key as keyof TirPmSkeletonLoaderStyleVars]};\n`;
    });
    styleElement.textContent = `
    :root {
      ${varsStr}
    }
  `;
    document.head.appendChild(styleElement);
  }

  constructor(obj?: Partial<TirPmSkeletonLoaderStyleVars>) {
    if (obj) Object.assign(this, obj);
  }
}
